import { render, staticRenderFns } from "./MobileMenuButton.vue?vue&type=template&id=d5240c2c&scoped=true"
import script from "./MobileMenuButton.vue?vue&type=script&lang=js"
export * from "./MobileMenuButton.vue?vue&type=script&lang=js"
import style0 from "./MobileMenuButton.vue?vue&type=style&index=0&id=d5240c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5240c2c",
  null
  
)

export default component.exports